import React, { useState, useRef, Fragment } from 'react';

import i18n from 'i18n-js';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import useStyles from './Dropdown.styled';
import { Box, Button } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { Menu, MenuItem } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import NestedMenuItem from 'material-ui-nested-menu-item';
import useInfiniteScroll from 'react-infinite-scroll-hook';

export const NestedDropdown = ({
  list,
  label,
  onClose,
  loading,
  onSearch,
  handleClick,
  hasMoreItems,
  fetchMoreData,
  displayNameField,
}) => {
  const [menuPosition, setMenuPosition] = useState(null);
  const classes = useStyles();
  const ref = useRef(null);
  // const { loading, hasNextPage, error } = useLoadItems();

  const [infiniteRef, { rootRef }] = useInfiniteScroll({
    loading: loading,
    hasNextPage: hasMoreItems,
    onLoadMore: fetchMoreData,
    disabled: loading,
  });

  const displayDropdown = (event) => {
    if (menuPosition) {
      return;
    }
    event.preventDefault();
    setMenuPosition({
      top: event.clientY,
      left: event.clientX,
    });
  };

  const handleItemClick = (item) => {
    if (handleClick) handleClick(item);
    setMenuPosition(null);
  };

  const stopImmediatePropagation = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <Box>
      <Button onClick={displayDropdown} className={classes.button} disabled={list.length === 0}>
        {label}
      </Button>
      <Menu
        autoFocus={false}
        open={!!menuPosition}
        disableAutoFocusItem={false}
        anchorPosition={menuPosition}
        anchorReference="anchorPosition"
        onClose={() => {
          if (onClose) onClose();
          setMenuPosition(null);
        }}
      >
        <MenuItem
          dense
          className={classes.menuItemInput}
          onKeyDown={(e) => e.stopPropagation()}
          onClickCapture={stopImmediatePropagation}
        >
          <InputBase
            autoFocus
            onChange={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onSearch(e.target.value);
            }}
            className={classes.input}
            placeholder={i18n.t('common.search')}
            inputProps={{ 'aria-label': 'search filter' }}
          />
          <IconButton type="submit" className={classes.iconButton} aria-label="search">
            <SearchIcon />
          </IconButton>
        </MenuItem>
        <Divider className={classes.divider} orientation="vertical" />
        <div style={{ height: 'auto', overflow: 'auto', maxHeight: 150 }} ref={rootRef}>
          {list?.map((item, index) => (
            <Fragment key={index}>
              {item?.children ? (
                <NestedMenuItem label={item.name} parentMenuOpen={!!menuPosition}>
                  {item?.children?.map((child, i) => (
                    <MenuItem key={i} onClick={() => handleItemClick(child)}>
                      {get(child, displayNameField)}
                    </MenuItem>
                  ))}
                </NestedMenuItem>
              ) : (
                <MenuItem dense onClick={() => handleItemClick(item)} component="span">
                  {get(item, displayNameField)}
                </MenuItem>
              )}
            </Fragment>
          ))}
          {hasMoreItems && (
            <MenuItem ref={infiniteRef} className={classes.menuLoadingItem}>
              <Box width={20} height={20}>
                <Loading />
              </Box>
            </MenuItem>
          )}
        </div>
      </Menu>
    </Box>
  );
};

NestedDropdown.propTypes = {
  list: PropTypes.array,
  onSearch: PropTypes.func,
  handleClick: PropTypes.func,
  label: PropTypes.string.isRequired,
  displayNameField: PropTypes.string.isRequired,
};

NestedDropdown.defaultProps = {
  list: [],
  label: '',
  onSearch: () => {},
  displayNameField: '',
  handleClick: () => {},
};

export default NestedDropdown;
